/**
 * Organisation selection fieldset for XeroManualForm.
 *
 * Extracted to reduce complexity of the parent form component.
 */

import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import type { Organisation } from '../../types'
import {
  NewOrgButton,
  OrganisationSelect,
  OrgStatusBanner,
} from './xero-org-fieldset/xero-org-fieldset.parts'

interface XeroOrgFieldsetProps {
  organisations: Organisation[]
  selectedOrgId: string
  isLoadingOrgs: boolean
  xeroOrganisationId: string
  onOrgChange: (orgId: string) => void
  onCreateOrganisation?: ((xeroOrgId?: string) => void) | undefined
  onConfirmLoseData: () => boolean
}

export function XeroOrgFieldset({
  organisations,
  selectedOrgId,
  isLoadingOrgs,
  xeroOrganisationId,
  onOrgChange,
  onCreateOrganisation,
  onConfirmLoseData,
}: XeroOrgFieldsetProps): ReactElement {
  const { t } = useTranslation('admin')
  const selectedOrg = organisations.find((item) => item.id === selectedOrgId)
  const handleCreateClick = (): void => {
    if (!onConfirmLoseData()) return
    onCreateOrganisation?.(xeroOrganisationId || undefined)
  }
  return (
    <fieldset className="space-y-4">
      <legend className="text-sm font-medium text-stone-700 dark:text-stone-300">
        {t('licensing.organisation')}
      </legend>
      <div className="flex gap-2">
        <OrganisationSelect
          organisations={organisations}
          selectedOrgId={selectedOrgId}
          isLoadingOrgs={isLoadingOrgs}
          onOrgChange={onOrgChange}
          t={t}
        />
        {onCreateOrganisation && <NewOrgButton onClick={handleCreateClick} t={t} />}
      </div>
      <OrgStatusBanner
        selectedOrg={selectedOrg}
        selectedOrgId={selectedOrgId}
        xeroOrganisationId={xeroOrganisationId}
        t={t}
      />
    </fieldset>
  )
}
